import catalog from '../backend/database/data/adami_motors_available_cars.json'

export const contact = {
  address: '6 Soi Keha Rom Klao 72, Intersection 5, Rat Phatthana Subdistrict, Saphan Sung District, Bangkok 10240, Thailand',
  phone: '+66 2 002 2899',
  email: 'adamimotorsthailand@gmail.com',
  weekday: '09:00 AM – 06:00 PM',
  saturday: '09:00 AM – 06:00 PM',
  sunday: 'Closed',
}

const uniq = values => [...new Set(values.filter(Boolean))].sort((a, b) => a.localeCompare(b))
const slug = value => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
const engineCc = value => {
  let cc = Number(value || 0)
  while (cc > 20000 && cc % 10 === 0) cc = cc / 10
  return cc ? `${cc.toLocaleString()} cc` : '-'
}

export const makers = uniq(catalog.map(car => car.maker))
export const types = uniq(catalog.map(car => car.type))

export const vehicles = catalog.map((car, i) => ({
  id: car.car_id || i + 1,
  slug: slug(`${car.title}-${car.year}-${car.car_code || car.car_id}`),
  maker: car.maker,
  model: car.model,
  title: car.title,
  type: car.type,
  year: car.year,
  price: car.price,
  currency: car.currency || 'USD',
  mileage: car.mileage || 0,
  engine: engineCc(car.engine_cc),
  transmission: car.transmission || '-',
  fuelType: car.fuel_type || '-',
  color: car.color || '-',
  steering: 'Right Hand Drive',
  availableCountries: ['Thailand'],
  status: car.status || 'available',
  featured: i < 12,
  discounted: car.status === 'discounted',
  description: `Available ${car.year} ${car.title} from Adami Motors Thailand with inspection and worldwide shipping support.`,
  images: car.images?.length ? car.images : ['/images/adami/adami-logo.jpg'],
  features: car.features || {},
  createdAt: `2026-07-${String((i % 25) + 1).padStart(2, '0')}`,
  carCode: car.car_code || car.car_id,
}))

export const services = [
 ['Car','Vehicle Sales & Procurement','Buy, sell or source quality new and used vehicles, including specialized Thai vehicles.'],
 ['Wrench','Custom Modifications','Performance, styling and functional customization shaped around your goals.'],
 ['Settings','Accessories Installation','Professional installation of essential and premium automotive accessories.'],
 ['Gauge','Maintenance & Repairs','Electrical, mechanical, maintenance and vehicle repair solutions.'],
 ['ShieldCheck','Vehicle Inspection','Detailed vehicle assessments that support informed buying decisions.'],
 ['Ship','Global Shipping','International shipping and export support from Thailand to destinations worldwide.'],
]

export const founders = [
 ['Aditsorn Gulikhandan Firdous Khan','Co-founder — Legal & Business Development','Builds transparent international partnerships and guides legal and business growth.','/images/adami/WhatsApp Image 2026-07-10 at 11.45.52 AM.jpeg'],
 ['Hamza Mohammad Yoshioka','Co-founder — Marketing, Sales & Shipping','Leads customer relationships, sales strategy and efficient global shipping.','/images/adami/WhatsApp Image 2026-07-10 at 11.45.53 AM.jpeg'],
 ['Rameez Zubair','Co-founder — Operations, Sales & Modifications','Oversees operations and vehicle transformations tailored to client needs.','/images/adami/WhatsApp Image 2026-07-10 at 11.45.54 AM.jpeg'],
 ['Behlum Mohammad Nadeem','Co-founder — Marketing, Operations & Sales','Connects marketing, operations and sales into a dependable client experience.','/images/adami/s.jpeg'],
]
export const staff = [
 ['Shoaib Khokhar','Accounts Manager','Supports financial management, field operations and client service.'],
 ['Bibiasmina Arabshah','Accounts Specialist','Manages financial processes with accuracy and transparency.'],
 ['Basri','Vehicle Modification Specialist','Transforms vehicles for appearance, functionality and performance.'],
]

export const money = n => new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:0}).format(n)
export const km = n => `${new Intl.NumberFormat('en-US').format(n)} km`
